import { useTranslation } from 'react-i18next';
import { Heart } from 'lucide-react';

export const PreferencesForm = ({ formData, setFormData }) => {
  const { t } = useTranslation();

  const updatePref = (field, value) => {
    setFormData(prev => ({ ...prev, preferences: { ...prev.preferences, [field]: value } }));
  };

  const RadioGroup = ({ name, label, options }) => (
    <div className="preference-group">
      <label className="preference-label">{label}</label>
      <div className="radio-buttons">
        {options.map(opt => (
          <label className="radio-button" key={opt.value}>
            <input type="radio" name={name} value={opt.value} checked={formData.preferences[name] === opt.value} onChange={(e) => updatePref(name, e.target.value)} />
            <span>{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );

  return (
    <div className="form-section" data-testid="preferences-section">
      <h2><Heart size={20} /> {t('createRide.sections.preferences')}</h2>
      <p className="section-description">{t('createRide.preferences.description')}</p>
      
      <div className="preferences-grid">
        <RadioGroup name="smoking" label={t('createRide.preferences.smoking')} options={[
          { value: 'not_allowed', label: t('createRide.preferences.smokingOptions.notAllowed') },
          { value: 'allowed', label: t('createRide.preferences.smokingOptions.allowed') }
        ]} />
        <RadioGroup name="pets" label={t('createRide.preferences.pets')} options={[
          { value: 'none', label: t('createRide.preferences.petsOptions.none') },
          { value: 'by_arrangement', label: t('createRide.preferences.petsOptions.byArrangement') }
        ]} />
        <RadioGroup name="music" label={t('createRide.preferences.music')} options={[
          { value: 'none', label: t('createRide.preferences.musicOptions.none') },
          { value: 'quiet', label: t('createRide.preferences.musicOptions.quiet') },
          { value: 'normal', label: t('createRide.preferences.musicOptions.normal') }
        ]} />
        <RadioGroup name="conversation" label={t('createRide.preferences.conversation')} options={[
          { value: 'quiet', label: t('createRide.preferences.conversationOptions.quiet') },
          { value: 'normal', label: t('createRide.preferences.conversationOptions.normal') },
          { value: 'chatty', label: t('createRide.preferences.conversationOptions.chatty') }
        ]} />
      </div>
    </div>
  );
};
